export default "__VITE_ASSET__BndsTu$x__"